import ActionTypes from '../constants';

const initialState = {
    batches: {},
    batch: {},
    // loading: false,
};

const batchReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETBATCHSUCCESS:
            return {
                ...state,
                batches: action.payload,
            }
        case ActionTypes.GETBATCHBYIDSUCCESS:
            return {
                ...state,
                batch: action.payload,
            }
        default:
            return state;
    }
}

export default batchReducer;